<template>
  <div>
    <div class="col-12 d-flex justify-content-end pr-0 mb-3">
        <button class="btn btn-sm btn-success" @click="modal.nuevoProveedor = true">Nuevo</button>
    </div>

    <div class="card">
        <div class="card-header d-flex justify-content-between">
            <h5>Clientes</h5>
            <div class="card-header-form">
                <input type="search" placeholder="Buscar..." class="form-control search">
            </div>
        </div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col">Razón social</th>
                <th scope="col">RFC</th>
                <th scope="col">Email</th>
                <th scope="col">Responsable</th>
                <th scope="col">Fecha de alta</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1</th>
                <td>Mark</td>
                <td>Otto</td>
                <td>@mdo</td>
                <td>@mdo</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <CModal title="Registrar nuevo proveedor" :show.sync="modal.nuevoProveedor" class="modalNoFooter">
      <div class="modal-body">
        <div class="form-group">
            <label for="">Razón social</label>
            <input type="text" class="form-control">
        </div>
        <div class="form-group">
            <label for="">RFC</label>
            <input type="text" class="form-control">
        </div>
        <div class="form-group">
            <label for="">Nombre del responsable</label>
            <input type="text" class="form-control">
        </div>
        <div class="form-group">
            <label for="">Email del responsable</label>
            <input type="text" class="form-control">
        </div>
      </div>

      <template #footer>
        <CButton @click="modal.nuevoProveedor = false" color="outline-secondary">Cancelar</CButton>
        <CButton color="primary">Registrar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Filepond from "../../componentes/tools/Docs.vue";

export default {
  components: {
    Filepond,
  },
  data() {
    return {
        modal: {
            nuevoProveedor: false
        },
        button: {
            uploadXML: true
        }
    };
  },

  methods: {
      handleUploadXml(base64) {
          this.button.uploadXML = false
      },
      handleCancelUploadXml() {
          this.button.uploadXML = true;
      }
  }
};
</script>